module.exports = __webpack_public_path__ + "static/media/pom-rebrand-bg.cf2381dd.svg";